import React, { Component } from "react";
import StatusDropdown from "../Shared/StatusDropdown";
import Button from "../../utils/Buttons";
import { withRouter } from "../../utils/withRouter";
import FullPageLoader from "../../common/FullPageLoader";
class StaffForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        fullName: "",
        email: "",
        mobileCountryCode: "+91",
        gender: "MALE",
        role: "STAFF",
        status: "ACTIVE",
        ...(props.initialData || {}),
      },
      errors: {},
    };
  }
  componentDidMount() {
    if (this.props.initialData) {
      this.fillForm(this.props.initialData);
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.clinics !== this.props.clinics && this.props.clinics) {
      this.setState((prevState) => ({
        formData: { ...prevState.formData, clinics: this.props.clinics },
      }));
    }
    if (
      this.props.initialData &&
      prevProps.initialData !== this.props.initialData
    ) {
      this.fillForm(this.props.initialData);
    }
  }
  fillForm = (data) => {
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        ...data,
      },
    }));
  };
  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [name]: value,
      },
      errors: {
        ...prevState.errors,
        [name]: "",
      },
    }));
  };
  handleSubmit = async (e) => {
    e.preventDefault();
    const { formData } = this.state;
    const payload = {
      fullName: formData.fullName?.trim(),
      email: formData.email?.trim(),
      gender: formData.gender,
    };
    payload.mobileCountryCode = String(formData.mobileCountryCode || "").trim();
    if (!this.props.initialData) {
      payload.role = formData.role;
    }
    if (this.props.initialData && formData.status) {
      payload.status = formData.status;
    }
    const result = await this.props.onSubmit(payload);
    const backendErrors = result?.error;
    if (backendErrors && typeof backendErrors === "object") {
      const fieldErrors = Object.fromEntries(
        Object.entries(backendErrors).map(([field, message]) => [
          field,
          Array.isArray(message) ? message.join(", ") : String(message),
        ]),
      );
      this.setState((prevState) => ({
        errors: { ...prevState.errors, ...fieldErrors },
      }));
    }
  };
  render() {
    const { loading, initialData } = this.props;
    const { formData, errors } = this.state;
    const isEdit = !!initialData;
    return (
      <>
      {loading && <FullPageLoader text="Saving..." />}
      <form onSubmit={this.handleSubmit} noValidate>
        <div className="card p-3">
          
          <div className="row">
            <div className="mb-3 col-md-6">
              <label>
                Full Name<span className="error">*</span>
              </label>
              <input
                type="text"
                name="fullName"
                className="form-control"
                placeholder="Enter full name"
                value={formData.fullName}
                onChange={this.handleChange}
              />
              {errors.fullName && (
                <span className="error">{errors.fullName}</span>
              )}
            </div>
            <div className="mb-3 col-md-6">
              <label>
                Email<span className="error">*</span>
              </label>
              <input
                type="email"
                name="email"
                className="form-control"
                placeholder="Enter email address"
                value={formData.email}
                onChange={this.handleChange}
              />
              {errors.email && <span className="error">{errors.email}</span>}
            </div>
          </div>
          <div className="row">
            <div className="mb-3 col-md-4">
              <label>Mobile</label>
              <input
                type="text"
                name="mobileCountryCode"
                className="form-control"
                placeholder="Enter mobile number"
                value={formData.mobileCountryCode}
                onChange={this.handleChange}
              />
              {errors.mobileCountryCode && <span className="error">{errors.mobileCountryCode}</span>}
            </div>
            {!isEdit && (
              <div className="mb-3 col-md-4">
                <label>Role</label>
                <select
                  name="role"
                  className="form-control staff-form-select"
                  value={formData.role}
                  onChange={this.handleChange}
                >
                  <option value="STAFF">STAFF</option>
                  <option value="ADMIN">ADMIN</option>
                </select>
              </div>
            )}
            <div className="mb-3 col-md-4">
              <label>
                Gender<span className="error">*</span>
              </label>
              <select
                name="gender"
                className="form-control staff-form-select"
                value={formData.gender}
                onChange={this.handleChange}
              >
                <option value="MALE">MALE</option>
                <option value="FEMALE">FEMALE</option>
              </select>
            </div>
            {isEdit && (
              <div className="mb-3 col-md-4">
                <label>Status</label>
                <StatusDropdown
                  name="status"
                  className="form-control staff-form-select"
                  value={formData.status}
                  onChange={this.handleChange}
                 activeLabel="ACTIVE" inactiveLabel="INACTIVE" />
              </div>
            )}
          </div>
          <div className="d-flex justify-content-end gap-2">
            <Button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
              text={loading ? "Saving..." : isEdit ? "Update Staff" : "Add Staff"}
            />
             <button
              type="button"
              className="btn"
              style={{ backgroundColor: "#032B4D", color: "#fff" }}
              onClick={() => this.props.navigate("/staff")}
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
      </>
    );
  }
}
export default withRouter(StaffForm);
